const getBrowserName = () => {
  const userAgent = navigator.userAgent

  const regexes = {
    chrome: /(?:chrome|crios)\/(\d+)/i,
    firefox: /(?:firefox|fxios)\/(\d+)/i,
    safari: /version\/(\d+).+?safari/i,
    edge: /edge\/(\d+)/i,
    ie: /trident.+?rv:(\d+)/i,
    opera: /(?:opera|opr)\/(\d+)/i,
  }

  for (const [browser, regex] of Object.entries(regexes)) {
    const match = userAgent.match(regex)
    if (match) {
      return browser
    }
  }

  return 'unknown'
}

const isMobile = () => {
  const userAgent = navigator.userAgent
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i
  return mobileRegex.test(userAgent)
}

export { getBrowserName, isMobile }
